export const isAuthenticated = ref(false);
// export const hasJwt = computed(() => {
//     const jwt = useCookie('jwt');
//     return jwt.value ? true : false;
// });

export const useHasJwt = () => {
    const jwt = useCookie('jwt');
    return computed(() => Boolean(jwt.value));
};

export const user = ref({});
export const userProfile = ref(null);

/*
    Profile completion for required onboarding.
    User is considered complete as soon as `prename` is set.
*/
export const isProfileComplete = (profile = user.value) => {
    const prename = profile?.prename;
    return typeof prename === 'string' && prename.trim().length > 0;
};

export const setUserProfile = (data = {}) => {
    user.value = {
        ...user.value,
        ...data,
    };
};

/*
    Set reactive user and isAuthenticated to true
*/
export const setUser = () => {
    const userToSet = useCookie('user');

    if (userToSet.value) {
        user.value = {
            ...user.value,
            ...userToSet.value,
        };

        isAuthenticated.value = true;
        return;
    }

    user.value = null;
    isAuthenticated.value = false;
};

/*
    Remove reactive user and set isAuthenticated to false
*/
export const removeUser = () => {
    user.value = null;
    isAuthenticated.value = false;
};

export const useUserMe = async () => {
    const { error: e, data } = await $fetch('/api/auth/me', {
        method: 'post',
    });

    if (e) {
        useSentryError(e, {
            useThrow: true,
            payload: null,
            response: data,
        });
    }

    setUserProfile(data);
};

/*
    Login
    @param {object} body - the login body
    @param {string} redirectUrl - the url to redirect to after login
*/
export const useLogin = async (body, isWin = false) => {
    const { error: e, data } = await $fetch('/api/auth/login', {
        method: 'post',
        body,
    });

    if (data?.notConfirmed || data?.wrongCredentials || data?.blocked) {
        return {
            data,
        };
    }

    if (e) {
        useSentryError(e, {
            useThrow: true,
            payload: body,
            response: data,
        });
    }

    setUser();

    const profileComplete = isProfileComplete();
    const shouldRedirectToWins = (isWin || data?.is_win === true) && profileComplete;
    const redirectUrl = shouldRedirectToWins ? '/your-wins' : '/dashboard';
    // const receiptDocumentIdCookie = useCookie('receiptDocumentId');
    // receiptDocumentIdCookie.value = null;

    if (redirectUrl) {
        const localePath = useLocalePath();
        const target = localePath(redirectUrl);
        await navigateTo(target, { replace: true });
    }

    return {};
};

/*
    Update
*/
export const useUpdateUser = async (body) => {
    const { error: e, data } = await $fetch('/api/auth/update', {
        method: 'post',
        body,
    });

    if (e) {
        useSentryError(e, {
            useThrow: true,
            payload: body,
            response: data,
        });
    }

    await useUserMe();
};

/*
    Delete
*/
export const useDeleteUser = async (redirectUrl) => {
    const { error: e, data } = await $fetch('/api/auth/delete', {
        method: 'post',
    });

    if (e) {
        useSentryError(e, {
            useThrow: true,
            payload: null,
            response: data,
        });
    }

    removeUser();

    if (redirectUrl) {
        const localePath = useLocalePath();
        navigateTo(localePath(redirectUrl));
    }
};

/*
    Logout
    @param {string} redirectUrl - the url to redirect to after logout
*/
export const useLogout = async (redirectUrl) => {
    await $fetch('/api/auth/logout', {
        method: 'post',
    });

    removeUser();

    if (redirectUrl) {
        const localePath = useLocalePath();
        navigateTo(localePath(redirectUrl));
    }
};
